export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активация электронного чека"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счет зачисления"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Серия"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код активации"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Проверить"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать электронный чек"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сумма"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активен"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирован"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отменён"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активируется"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Возврат"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В обработке"])}
  }
}